import { createStore } from '@/zustand/storeCreator';

interface CityState {
  selectedCity: string;
  setSelectedCity: (city: string) => void;
  cityValue: string;
  setCityValue: (city: string) => void;
}

export const useCityStore = createStore<CityState>(
  set => ({
    selectedCity:
      typeof window !== 'undefined'
        ? JSON.parse(localStorage.getItem('selected-city') || '{}')?.state
            ?.selectedCity || ''
        : '',
    setSelectedCity: city => set(() => ({ selectedCity: city })),
    cityValue: '',
    setCityValue: city => set(() => ({ cityValue: city })),
  }),
  { name: 'selected-city' }
);
